module.exports = __webpack_public_path__ + "static/potted_plants-40a9d569f4e8990f63ab93a80a6ebf4c.png";